var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06641 6.43424C7.66714 6.69864 7.28827 7.0067 6.93654 7.35844C4.10339 10.1916 4.10339 14.785 6.93654 17.6182C9.76969 20.4513 14.3631 20.4513 17.1963 17.6182C20.0294 14.785 20.0294 10.1916 17.1963 7.35844C16.8445 7.0067 16.4657 6.69864 16.0664 6.43424",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 4.66699V9.07202",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogout);
export default __webpack_public_path__ + "static/media/header-logout.67654291cc3c186cb761bcd66b6c5621.svg";
export { ForwardRef as ReactComponent };